import { useEffect } from 'react';

import { useReport } from '@motorway/motorway-handshake-components';
import { AgentsBoxCard } from '@motorway/motorway-handshake-components';

import { clearSessionToken } from '../../api/helpers/auth.helpers';
import { Header } from '../../components/Header/Header';
import { VehicleCard } from '../../components/VehicleCard/VehicleCard';
import { snowplowCtaClick } from '../../helpers/snowplow';

import styles from './Finished.module.scss';

const HandshakeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path d="M40.0898 16.01H36.7098C36.7098 16.01 36.6598 16.02 36.6298 16.03L29.8698 11.09C28.0998 9.79997 25.8398 9.67997 23.9898 10.63C22.1198 9.66997 19.8398 9.81997 18.0898 11.09L11.3398 16.03C11.3398 16.03 11.2998 16.02 11.2898 16.02H7.90977C5.75977 16.02 4.00977 17.77 4.00977 19.92V28.13C4.00977 30.28 5.75977 32.03 7.90977 32.03H12.8298C13.6898 32.03 14.5398 32.32 15.2198 32.85L20.0898 36.64C21.2598 37.55 22.6698 38 24.0798 38C25.4898 38 26.7698 37.59 27.8998 36.76L32.3898 33.49C32.9198 33.11 33.3098 32.59 33.5898 32.02H40.0798C42.2298 32.02 43.9798 30.27 43.9798 28.12V19.91C43.9798 17.76 42.2298 16.01 40.0798 16.01H40.0898ZM28.3398 13.18L35.4098 18.35V29.42H33.8798C33.7198 28.78 33.4298 28.18 32.9698 27.69L26.9898 21.22H29.4498C30.1698 21.22 30.7498 20.64 30.7498 19.92C30.7498 19.2 30.1698 18.62 29.4498 18.62H26.1398C25.7998 18.62 25.4598 18.76 25.2198 19L23.7898 20.43C22.3198 21.9 19.7498 21.9 18.2798 20.43L17.8698 20.02L24.4098 13.47C25.4798 12.4 27.1298 12.28 28.3498 13.17L28.3398 13.18ZM6.60977 28.12V19.91C6.60977 19.19 7.18977 18.61 7.90977 18.61H9.98977V29.42H7.90977C7.18977 29.42 6.60977 28.84 6.60977 28.12ZM30.8698 31.39L26.3798 34.66C24.9798 35.68 23.0498 35.65 21.6898 34.58L16.8198 30.79C15.6798 29.91 14.2698 29.42 12.8298 29.42H12.5898V18.33L19.6298 13.18C20.2198 12.75 20.9098 12.57 21.5998 12.61L16.0198 18.19C15.5298 18.68 15.2598 19.33 15.2598 20.03C15.2598 20.73 15.5298 21.38 16.0198 21.87L16.4298 22.28C17.6598 23.51 19.2898 24.18 21.0298 24.18C22.4698 24.18 23.8298 23.71 24.9598 22.85L31.0698 29.46C31.3198 29.74 31.4498 30.09 31.4098 30.47C31.3698 30.84 31.1898 31.17 30.8798 31.39H30.8698ZM41.3898 28.12C41.3898 28.84 40.8098 29.42 40.0898 29.42H38.0098V18.61H40.0898C40.8098 18.61 41.3898 19.19 41.3898 19.91V28.12Z" fill="white" />
  </svg>
);

export const Finished = () => {
  const { report } = useReport();
  const { inspection } = report ?? {};
  const { outcome } = inspection ?? {};

  const isCancelled = outcome === 'cancelled';

  useEffect(() => {
    clearSessionToken();
  }, []);

  return (
    <div className={styles.component}>
      <Header>
        { !isCancelled && <HandshakeIcon /> }
        {
          isCancelled
            ? (
                <h1>Collection cancelled</h1>
              )
            : (
                <h1>Collection ended</h1>
              )
        }
        {isCancelled
          ? (
              <p>The purchase has been cancelled. Please contact support if you have any questions.</p>
            )
          : (
              <p>You can now close this tab and drive away in the vehicle. Thanks for using Motorway!</p>
            )}
      </Header>
      {
        isCancelled && (<AgentsBoxCard clickCallback={snowplowCtaClick} />)
      }
      <VehicleCard />
    </div>
  );
};
